import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faCircleExclamation, faLock, faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';

export type AuthErrorType = 'not-found' | 'forbidden' | 'error';

export interface ErrorConfig {
  icon: IconDefinition;
  code: string;
  title: string;
  message: string;
}

export const ERROR_CONFIGS: Record<AuthErrorType, ErrorConfig> = {
  'not-found': {
    icon: faMagnifyingGlass,
    code: '404',
    title: 'Page Not Found',
    message: "The page you're looking for doesn't exist or has been moved.",
  },
  'forbidden': {
    icon: faLock,
    code: '403',
    title: 'Access Denied',
    message: "You don't have permission to view this page.",
  },
  'error': {
    icon: faCircleExclamation,
    code: '500',
    title: 'Something Went Wrong',
    message: 'Sorry, we ran into a problem. Please try again.',
  },
};

@Component({
    selector: 'app-auth-error-display',
    templateUrl: './auth-error-display.component.html',
    styleUrls: ['./auth-error-display.component.scss'],
    standalone: false
})
export class AuthErrorDisplayComponent implements OnInit {
  @Input() type: AuthErrorType = 'error';
  @Input() message?: string;
  @Input() attemptedUrl?: string;

  constructor(
    private router: Router,
  ) { }

  get actionLabel(): string {
    return this.type === 'error' ? 'Continue' : 'Go to dashboard';
  }

  get config(): ErrorConfig {
    return this.message
      ? { ...ERROR_CONFIGS[this.type], message: this.message }
      : ERROR_CONFIGS[this.type];
  }

  ngOnInit(): void {
    this.router.navigate(['/'], {
      replaceUrl: true,
      state: {
        authErrorModal: {
          type: this.type,
          title: this.config.title,
          message: this.config.message,
          attemptedUrl: this.attemptedUrl ?? this.router.url,
          openedAt: Date.now(),
        }
      }
    });
  }
}
